export const PERMISSIONS = Object.freeze({
  manage_associates: {
    title: 'Manage Associates',
    description: "Can view / edit associates' profiles.",
    group: 'administrator',
    hasScope: true
  },
  manage_shifts: {
    title: 'Manage Shifts',
    description: "Can view / edit associates' shifts.",
    group: 'administrator',
    hasScope: true
  },
  manage_documents: {
    title: 'Manage Documents',
    description:
      'Can view / edit / add / send to sign documents. Can manage Onboarding / Departure process for associates.',
    group: 'administrator',
    hasScope: false
  },
  manage_schedule: {
    title: 'Manage Schedule',
    description: "Can view / edit the company's schedule.",
    group: 'administrator',
    hasScope: false
  },
  manage_authorizations: {
    title: 'Manage Violations',
    description: 'Can view, accept, and deny associate violations.',
    group: 'administrator',
    hasScope: true
  },
  manage_project: {
    title: 'Manage Company',
    description: 'Can edit company settings and information.',
    group: 'administrator',
    hasScope: false
  },
  resolve_alerts: {
    title: 'Resolve Alerts',
    description: "Can view / resolve any company's alerts.",
    group: 'administrator',
    hasScope: false
  },
  validate_payments: {
    title: 'Validate Payments',
    description: "Can validate associates' invoices.",
    group: 'administrator',
    hasScope: true
  },
  process_payments: {
    title: 'Process Payments',
    description: "Can process associates' invoices.",
    group: 'administrator',
    hasScope: true
  },
  manage_marketplace: {
    title: 'Manage Marketplace',
    description: 'Can process marketplace.',
    group: 'administrator',
    hasScope: false
  },
  send_push_notification: {
    title: 'Send Notification',
    description: 'Can send announcements to associates.',
    group: 'supervisor',
    hasScope: false
  },
  floating_work_area: {
    title: 'Floating Work Area',
    description: 'Can work from any location.',
    group: 'supervisor',
    hasScope: false
  },
  invite_user: {
    title: 'Invite User',
    description: 'Can invite users to company.',
    group: 'administrator',
    hasScope: false
  },
  mobile_time_tracking: {
    title: 'Mobile Time Tracking',
    description: 'Associate can clock in / clock out using mobile app. Otherwise associate required to use terminal.',
    group: 'worker',
    hasScope: false
  },
  manual_shift: {
    title: 'Creating Manual Shifts',
    description: 'Associate may / may not have the ability to create Manual shifts.',
    group: 'worker',
    hasScope: false
  },
  adjust_shift: {
    title: 'Adjusting Time',
    description:
      'Associate can edit the Tracked time in both directions when signing and adjusting a Shift. When disabled, Associate will not be able to increase the Tracked time.',
    group: 'worker',
    hasScope: false
  }
})

export const PERMISSION_GROUPS = Object.freeze({
  WORKER: 'worker',
  SUPERVISOR: 'supervisor',
  ADMINISTRATOR: 'administrator'
})
